module.exports = __webpack_public_path__ + "img/sceneIcon3-1.78a71052.png";